
export enum DurationUnits {
  Days = "Days",
  Months = "Months",
  Years = "Years",
  Lifetime = "Lifetime"
}

class Duration {
  amount: number
  units: DurationUnits

  constructor (data: any) {
    this.amount = data.amount
    this.units = data.units
  }
}

export default Duration